'use client';

import { useInitAnalytics } from '@chewy/use-analytics';

const convertRegion = (region: string) => {
  if (region === 'us-east-2') {
    return 'use2';
  } else {
    return 'use1';
  }
};

export default function AnalyticsInit({ region, env }: { region?: string; env?: string }) {
  const newEnv = env as 'dev' | 'prd' | 'stg' | 'qat';
  const newRegion = convertRegion(region || 'use1');

  const initData = {
    appName: 'onlineHelpCenter',
    appVersion: '1.0.0',
    pageType: 'helpCenter',
    environment: newEnv as 'dev' | 'prd' | 'stg' | 'qat',
    region: newRegion as 'use2' | 'use1',
    automaticPageViews: false
  };
  console.log('******** initData ********', initData);
  useInitAnalytics(initData);

  return null;
}
